<template>
    <div>
        <input-label v-if="label"
            :for_element="name"
            class="leading-snug"
        >{{ $t(label) }}</input-label>

        <ul class="flex flex-none sm:-mr-6"
            :class="{
                'flex-col': vertical,
                'flex-row-reverse justify-end': reverse,
            }"
        >
            <input-radio-button
                :value="1"
                :label="$t(true_value)"
                :selected="selected"
                @selected="select"
                :read_only="read_only"
            />

            <input-radio-button
                :value="0"
                :label="$t(false_value)"
                :selected="! selected"
                @selected="select"
                :read_only="read_only"
            />

            <input type="hidden" :name="name" :value="selected" />
        </ul>
    </div>
</template>

<script>
import InputRadioButton from './input-radio-button.vue';

export default {
    components: {
        InputRadioButton,
    },

    props: {
        label: {},
        name: {},
        value: {},
        true: {},
        false: {},
        vertical: { default: false },
        reverse: { default: false },
        read_only: { default: false },
    },

    data() {
        return {
            selected: this.value ? 1 : 0,
            true_value: this.true,
            false_value: this.false,
        }
    },

    methods: {
        select(value) {
            if (! this.read_only) {
                this.selected = value;
                this.$emit('input', value);
            }
        },
    },
}
</script>
